import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo5.mp4';

import image1 from '@src/assets/images/solution/constructionSafety/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSafety/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSafety/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSafety/img/4.avif';

export default {
  type: '건설 솔루션',
  banner: {
    title: '건설현장 작업자의 위험을 즉시 감지하고 대응하세요.',
    desc: '작업자의 위치를 실시간으로 파악하고 위험 상황 발생 시 즉각 대응하여 현장 안전을 강화합니다.',
  },

  video: {
    title: '실시간 위치 데이터를 통해 건설현장 안전관리를 최적화하세요.',
    desc: '현장 작업자의 실시간 위치를 정확히 추적하여 위험 요소를 사전에 파악하고 신속히 대응할 수 있어, 현장 운영의 안전성과 효율성을 높입니다.',
    play: mainVideo,
  },

  func: [
    {
      theme: '작업자의 위치를 실시간으로 모니터링하여 사고 위험을 최소화하세요.',
      title: '작업자 위치 실시간 추적',
      desc: '작업자의 현재 위치를 ±50cm 이내의 정밀도로 실시간으로 파악하여 현장 내 사고 위험을 즉시 감지합니다. 이를 통해 즉각적인 사고 대응 및 예방조치를 취할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '위험구역 진입 시 자동 알림',
      desc: '작업자가 지정된 위험 구역에 접근하거나 진입할 경우, 관리자는 즉시 알림을 수신합니다. 이를 통해 현장 작업자의 안전을 확보하고 잠재적인 사고를 방지합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '빠른 데이터 연동',
      icon2: IconTvocGray,
      video: subVideo2,
    },
    {
      title: '중장비 위치 동시 확인',
      desc: '중장비에도 위치 추적 태그를 부착하여, 장비의 이동 경로와 현재 위치를 작업자와 함께 통합적으로 관리할 수 있습니다. 이를 통해 중장비와 작업자의 충돌 위험을 줄이고, 장비 운영 효율도 동시에 높일 수 있습니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      video: subVideo3,
    },
    {
      title: '작업자 이동 경로 기록 및 사고 예방 활용',
      desc: '작업자의 이동 경로를 기록하여 사고 발생 시 신속히 대응할 수 있으며, 위험 경로를 사전에 분석하여 안전 관리 계획에 활용합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo4,
    },
    {
      theme: '데이터로 안전을 기록하고 더 나은 운영을 시작하세요',
      title: 'CCTV 연동을 통한 안전 모니터링',
      desc: '작업자의 위치 데이터와 현장 CCTV 영상을 실시간으로 연동하여 현장 상황을 즉각적으로 시각화합니다. 위험 발생 시 작업자의 위치와 주변 상황을 CCTV 영상으로 바로 확인하여 더욱 빠르고 정확하게 대응할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image1,
    },
    {
      title: '자동화된 안전 관리 보고서 생성',
      desc: '매일 또는 매주 단위로 안전 관리 보고서가 자동으로 생성되어 관리자에게 제공됩니다. 사고 현황 및 예방 조치 결과를 체계적으로 정리하여 효율적인 관리가 가능합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image2,
    },
    {
      title: '위험 상황 발생 이력 데이터 분석',
      desc: '과거의 위험 상황 및 작업자 이동 데이터를 분석하여 사고가 자주 발생한 구역과 상황을 명확히 파악하고, 이를 기반으로 향후 안전 관리 계획을 개선합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image3,
    },
    {
      title: '인력 배치 최적화 지원',
      desc: '작업자 밀집도와 이동 데이터를 분석하여 현장 운영 인력 배치를 최적화하고 효율적인 인력 관리로 운영 비용을 절감할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '',

    data: [
      {
        icon: IconLocation, // 위치 실시간 추적 → Location: 위치 직접 표현
        title: '작업자 위치 실시간 추적',
        desc: '작업자의 위치를 ±50cm 이내로 실시간 정확히 추적합니다.',
      },
      {
        icon: IconWarning, // 위험 구역 알림 → Warning: 위험 직접 표현
        title: '위험 구역 진입 자동 알림',
        desc: '작업자가 위험 구역에 진입하면 즉시 관리자에게 알림을 전송합니다.',
      },
      {
        icon: IconCar, // 중장비 위치 동시 모니터링 → Car: 장비/차량 상징
        title: '중장비 위치 동시 모니터링',
        desc: '중장비와 작업자의 위치를 동시에 관리해 충돌 위험을 예방합니다.',
      },
      {
        icon: IconRoute, // 이동 경로 기록 → Route 유지
        title: '작업자 이동경로 기록',
        desc: '작업자 이동 경로를 자동 기록하여 위험 예방과 사고 대응에 활용합니다.',
      },
      {
        icon: IconCctvLine, // CCTV 연동 지원 → CCTV 라인 아이콘
        title: 'CCTV 연동 지원',
        desc: '작업자 위치와 CCTV 영상을 연동해 현장 상황을 실시간으로 시각화합니다.',
      },
      {
        icon: IconChartBar, // 안전 관리 보고서 생성 → ChartBar: 리포트/분석 의미
        title: '안전 관리 보고서 생성',
        desc: '작업자의 안전 현황과 사고 데이터를 자동으로 분석해 보고서를 제공합니다.',
      },
      {
        icon: IconSearch, // 인력 밀집 현황 관리 → People: 인력 군집 상징
        title: '인력 밀집 현황 관리',
        desc: '현장 인력의 밀집도를 실시간 관리하고, 기준 초과 시 알림을 제공합니다.',
      },
      {
        icon: IconLayers, // 인력 배치 최적화 → Layers: 구조/배치 의미
        title: '인력 배치 최적화 지원',
        desc: '작업자 밀집도를 분석하여 운영 인력을 효율적으로 배치합니다.',
      },
      {
        icon: IconAnalytics, // 위험 상황 데이터 분석 → Analytics: 분석 강조
        title: '위험 상황 데이터 분석',
        desc: '과거 위험 데이터를 분석하여 사고 예방 계획을 수립합니다.',
      },
      {
        icon: IconSecurity, // 감사 대응 → Security 유지 (신뢰성/보안)
        title: '안전 감사 대응 이력 활용',
        desc: '작업자의 위치 및 이동 데이터를 감사 및 규제 대응 자료로 활용합니다.',
      },
    ],
  },
  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
